import { Rectangle } from "./Rectangle";
import { Point } from "./Point";
import { Size } from "./Size";
import { IGeometry } from "./IGeometry";

export class Geometry {
    constructor(public rectangle: Rectangle = new Rectangle(), public zIndex: number = 0) { }

    move(difference: Point): Geometry {
        return new Geometry(
            this.rectangle.move(difference),
            this.zIndex);
    }

    moveTo(topLeft: Point): Geometry {
        return new Geometry(
            this.rectangle.moveTo(topLeft),
            this.zIndex);
    }

    add(difference: Rectangle): Geometry {
        return new Geometry(
            this.rectangle.add(difference),
            this.zIndex
        );
    }

    subtract(difference: Rectangle): Geometry {
        return new Geometry(
            this.rectangle.subtract(difference),
            this.zIndex
        );
    }

    multiply(multiplier: number): Geometry {
        return new Geometry(
            this.rectangle.multiply(multiplier),
            this.zIndex
        );
    }

    reverse(): Geometry {
        return new Geometry(
            this.rectangle.reverse(),
            this.zIndex
        );
    }

    clone(): Geometry {
        return new Geometry(
          this.rectangle.clone(),
          this.zIndex
        );
    }

    static from(source: IGeometry): Geometry {
        if (!source) {
            return null;
        }
        return new Geometry(new Rectangle(new Point(source.x, source.y), new Size(source.width, source.height)), source.zIndex);
    }

    static to(source: Geometry): IGeometry {
        if (!source) {
            return null;
        }
        return {
            x: source.rectangle.x,
            y: source.rectangle.y,
            width: source.rectangle.width,
            height: source.rectangle.height,
            zIndex: source.zIndex,
        };
    }
}
